// stripe connect
export const STRIPE_PAYMENT_TYPE_ID = 'stripe';

// stripe api key
export const S_API_KEY_PAYMENT_TYPE_ID = 'sapikey';

// unable to auto collect fees by platform 
export const PAYPAL_PAYMENT_TYPE_ID = 'paypal';
export const CASH_PAYMENT_TYPE_ID = 'cash';
export const CARD_TERMINAL_PAYMENT_TYPE_ID = 'cardTerminal';